var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tenantType === 'ENERGY')?_c('EmpresaEnergyView',{attrs:{"guid":_vm.guid}}):_vm._e(),(_vm.tenantType === 'FINANCE')?_c('EmpresaFinanceView',{attrs:{"guid":_vm.guid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }